export enum StatsFetchType {
  STATS = "stats",
  VIEW_PER_CURRENCY = "viewPerCurrency",
  EXPAND_SUM = "expandSum",
}
